const locale = {
  advisorAssignments: "advisorAssignments",
  assignmentsView: "assignmentsView",
  assignmentsLive: "assignmentsLive",
  assignmentsByDate: "assignmentsByDate",
  assignmentsAdvisor: "assignmentsAdvisor",
  assignmentsManual: "assignmentsManual",
  assignmentsRoundRobin: "assignmentsRoundRobin",
  assignmentsTotalActive: "assignmentsTotalActive",
  assignmentsTotalAssigned: "assignmentsTotalAssigned",
  assignmentsRefresh: "assignmentsRefresh",
  assignmentsManualHelp: "assignmentsManualHelp",
  assignmentsHistoryHelp: "assignmentsHistoryHelp",
  assignmentsInvalidDates: "assignmentsInvalidDates",
  assignmentsLoadError: "assignmentsLoadError",
  assignmentsUnclassified: "assignmentsUnclassified",
  assignmentsUnknownHelp: "assignmentsUnknownHelp",
  assignmentsEmpty: "assignmentsEmpty",
  adReportColumns: "adReportColumns",
  adReportColumnLabel: "adReportColumnLabel",
  adReportContactField: "adReportContactField",
  adReportColumnsHelp: "adReportColumnsHelp",
  adReportAddColumn: "adReportAddColumn",
  adReportColumnsInvalid: "adReportColumnsInvalid",
  adReportColumnsSaveError: "adReportColumnsSaveError",
  adReportLoadError: "adReportLoadError",
  adReportExport: "adReportExport",

  errorLoadingPage: "errorLoadingPage",
  signIn: "signIn",
  signUp: "signUp",
  genericError: "genericError",
  invalidEmail: "invalidEmail",
  fieldRequired: "fieldRequired",
  passwordMinLength: "passwordMinLength",
  wrongPassword: "wrongPassword",
  userDisabled: "userDisabled",
  userNotFound: "userNotFound",
  email: "email",
  password: "password",
  name: "name",
  or: "or",
  signInWith: "signInWith",
  signInWelcomeBack: "signInWelcomeBack",
  signInWelcomeBackEnterYourDetails: "signInWelcomeBackEnterYourDetails",
  signInDontHaveAnAccount: "signInDontHaveAnAccount",
  signUpWith: "signUpWith",
  signUpAlreadyHaveAnAccount: "signUpAlreadyHaveAnAccount",
  acceptTerms: "acceptTerms",
  signUpToWelcome: "signUpToWelcome",
  signUpToBegin: "signUpToBegin",
  letsLinkYourBot: "letsLinkYourBot",
  botId: "botId",
  key: "key",
  linkBot: "linkBot",
  canNotLinkBot: "canNotLinkBot",
  linkAccounts: "linkAccounts",
  confirm: "confirm",
  connect: "connect",
  disconnect: "disconnect",
  send: "send",
  details: "details",
  save: "save",
  firstName: "firstName",
  lastName: "lastName",
  writeMessage: "writeMessage",
  notes: "notes",
  writeNote: "writeNote",
  add: "add",
  chats: "chats",
  logOut: "logOut",
  cannedResponses: "cannedResponses",
  addCanResponses: "addCanResponses",
  contacts: "contacts",
  addContact: "addContact",
  writeCannedResponse: "writeCannedResponse",
  labels: "labels",
  addLabel: "addLabel",
  open: "open",
  done: "done",
  markAsOpen: "markAsOpen",
  markAsDone: "markAsDone",
  sessionTimeout: "sessionTimeout",
  stillHere: "stillHere",
  youWillBeLoggedOutDescription: "youWillBeLoggedOutDescription",
  day: "day",
  from: "from",
  to: "to",
  sunday: "sunday",
  monday: "monday",
  tuesday: "tuesday",
  wednesday: "wednesday",
  thursday: "thursday",
  friday: "friday",
  saturday: "saturday",
  agentsOutOfScheduleMessage: "agentsOutOfScheduleMessage",
  agentsSchedule: "agentsSchedule",
  settings: "settings",
  requested: "requested",
  connected: "connected",
  all: "all",
  delete: "delete",
  askDeleteConfirmation: "askDeleteConfirmation",
  cancel: "cancel",
  cannedResponsesDescription: "cannedResponsesDescription",
  schedule: "schedule",
  scheduleDescription: "scheduleDescription",
  noRequestsChats: "noRequestsChats",
  noConnectedChats: "noConnectedChats",
  noAllChats: "noAllChats",
  askSettingsSaveConfirmation: "askSettingsSaveConfirmation",
  searchChats: "searchChats",
  timezone: "timezone",
  addBot: "addBot",
  botAlreadyAdded: "botAlreadyAdded",
  fileIsTooLarge: "fileIsTooLarge",
  fileHasNoSupportedFormat: "fileHasNoSupportedFormat",
  myQueue: "myQueue",
  onlineAgents: "onlineAgents",
  chatAssignedToYou: "chatAssignedToYou",
  accept: "accept",
  reject: "reject",
  usersAllowedToAssignChats: "usersAllowedToAssignChats",
  scheduledChatClosingDialog: "scheduledChatClosingDialog",
  scheduledChatClosingDialogAt: "scheduledChatClosingDialogAt",
  rootUser: "rootUser",
  superAdminUser: "superAdminUser",
  administratorUser: "administratorUser",
  supervisorUser: "supervisorUser",
  collaboratorUser: "collaboratorUser",
  agentConnected: "agentConnected",
  anAgentIsAlreadyConnected: "anAgentIsAlreadyConnected",
  calling: "calling",
  rejected: "rejected",
  timedOut: "timedOut",
  canceled: "canceled",
  ongoing: "ongoing",
  callEnded: "callEnded",
  leavingEndsCall: "leavingEndsCall",
  disableVideoCall: "disableVideoCall",
  users: "users",
  userEdit: "userEdit",
  userType: "userType",
  search: "search",
  analytics: "analytics",
  dateFilter: "dateFilter",
  addMetric: "addMetric",
  channel: "channel",
  metricAlreadyAdded: "metricAlreadyAdded",
  allChannels: "allChannels",
  liveStream: "liveStream",
  noCurrentLiveStream: "noCurrentLiveStream",
  startLiveStream: "startLiveStream",
  setUpLiveStream: "setUpLiveStream",
  streamNameKey: "streamNameKey",
  streamLocationUrl: "streamLocationUrl",
  stopLiveStream: "stopLiveStream",
  noPastLiveChats: "noPastLiveChats",
  groups: "groups",
  scheduleHelperText: "scheduleHelperText",
  selectLiveStreamGroup: "selectLiveStreamGroup",
  resourceNotFound: "resourceNotFound",
  messageDeleted: "messageDeleted",
  story: "story",
  storyDeletedOrExpired: "storyDeletedOrExpired",
  newMessageReceived: "newMessageReceived",
  showRequestedChatsNotifications: "showRequestedChatsNotifications",
  showMyChatsNotifications: "showMyChatsNotifications",
  campaigns: "campaigns",
  pastCampaigns: "pastCampaigns",
  createCampaignDescription: "createCampaignDescription",
  createCampaign: "createCampaign",
  uploadAudience: "uploadAudience",
  launchCampaign: "launchCampaign",
  startCampaign: "startCampaign",
  custom: "custom",
  manualUpload: "manualUpload",
  campaignName: "campaignName",
  campaignData: "campaignData",
  file: "file",
  noPastCampaigns: "noPastCampaigns",
  template: "template",
  allDay: "allDay",
  closed: "closed",
  closeAll: "closeAll",
  addAsContact: "addAsContact",
  removeFromContacts: "removeFromContacts",
  createdAt: "createdAt",
  creationDate: "creationDate",
  apply: "apply",
  clear: "clear",
  lastMessage: "lastMessage",
  contact: "contact",
  phoneNumber: "phoneNumber",
  addField: "addField",
  typeNameField: "typeNameField",
  board: "board",
  createBoard: "createBoard",
  create: "create",
  addFirstColumn: "addFirstColumn",
  addFirstColumnDesc: "addFirstColumnDesc",
  column: "column",
  updateColumn: "updateColumn",
  askForColumnName: "askForColumnName",
  sendToBoard: "sendToBoard",
  removeFromBoard: "removeFromBoard",
  table: "table",
  tableHeader: "tableHeader",
  bulkUpload: "bulkUpload",
  manualInput: "manualInput",
  recipients: "recipients",
  message: "message",
  history: "history",
  noLogs: "noLogs",
  changedFields: "changedFields",
  changedPosition: "changedPosition",
  movedToBoard: "movedToBoard",
  movedToColumn: "movedToColumn",
  removedFromBoard: "removedFromBoard",
  addedAsContact: "addedAsContact",
  removedAsContact: "removedAsContact",
  empty: "empty",
  previous: "previous",
  next: "next",
  pagination: "pagination",
  goToPage: "goToPage",
  invalidInput: "invalidInput",
  pageSize: "pageSize",
  contactsMerged: "contactsMerged",
  noContactsMerged: "noContactsMerged",
  mergedContact: "mergedContact",
  unmergedContact: "unmergedContact",
  access: "access",
  noAccessToThisResource: "noAccessToThisResource",
  assignee: "assignee",
  none: "none",
  label: "label",
  liveChatConnected: "liveChatConnected",
  liveChatDisconnected: "liveChatDisconnected",
  hours: "hours",
  immediately: "immediately",
  showCard: "showCard",
  contactAlreadyExists: "contactAlreadyExists",
  botTransferred: "botTransferred",
  maxChatsAssigned: "maxChatsAssigned",
  maxCallsAssigned: "maxCallsAssigned",
  maxChatsPerGroup: "maxChatsPerGroup",
  unlimited: "unlimited",
  noCollaboratorsAvailable: "noCollaboratorsAvailable",
  agentsOutOfScheduleDialog: "agentsOutOfScheduleDialog",
  agentsOutOfScheduleDialogTooltip: "agentsOutOfScheduleDialogTooltip",
  ofLast7Days: "ofLast7Days",
  mostActiveSchedule: "mostActiveSchedule",
  conversationsOverTime: "conversationsOverTime",
  messagesOverTime: "messagesOverTime",
  todayTraffic: "todayTraffic",
  chatsConnected: "chatsConnected",
  chatsDisconnected: "chatsDisconnected",
  channels: "channels",
  total: "total",
  collaborator: "collaborator",
  messagesSent: "messagesSent",
  meanTimeToConnect: "meanTimeToConnect",
  averageHandlingTime: "averageHandlingTime",
  firstMessageTime: "firstMessageTime",
  averageFirstMessageTime: "averageFirstMessageTime",
  teamPerformance: "teamPerformance",
  countContacts: "countContacts",
  showRequestedChats: "showRequestedChats",
  blocked: "blocked",
  blockUser: "blockUser",
  unblockUser: "unblockUser",
  blockedUser: "blockedUser",
  unblockedUser: "unblockedUser",
  topDialogNames: "topDialogNames",
  billing: "billing",
  addCard: "addCard",
  addCardDescription: "addCardDescription",
  card: "card",
  cardEndingIn: "cardEndingIn",
  expiry: "expiry",
  month: "month",
  currentPlan: "currentPlan",
  choose: "choose",
  chatBotWithAi: "chatBotWithAi",
  upToHumanAgents: "upToHumanAgents",
  includesWaMessages: "includesWaMessages",
  waNumberConfig: "waNumberConfig",
  allOFPlus: "allOFPlus",
  apiAccess: "apiAccess",
  dedicatedAccountManager: "dedicatedAccountManager",
  customizePlatform: "customizePlatform",
  customApiDevelopment: "customApiDevelopment",
  unlimitedHumanAgents: "unlimitedHumanAgents",
  availablePlans: "availablePlans",
  extraAgents: "extraAgents",
  extraAgentsTooltip: "extraAgentsTooltip",
  planDetails: "planDetails",
  price: "price",
  agentsIncluded: "agentsIncluded",
  agentPrice: "agentPrice",
  tieredPrices: "tieredPrices",
  tieredPricesTooltip: "tieredPricesTooltip",
  moreThan: "moreThan",
  upgradePlanToUseThisResource: "upgradePlanToUseThisResource",
  botHasAgentsLimit: "botHasAgentsLimit",
  edit: "edit",
  editCard: "editCard",
  addCardSetUp: "addCardSetUp",
  addCardSetUpDescription: "addCardSetUpDescription",
  viewSource: "viewSource",
  letsAdd2fa: "letsAdd2fa",
  verifyItsYou: "verifyItsYou",
  sendSMS: "sendSMS",
  weWillSendSms: "weWillSendSms",
  registerNumber: "registerNumber",
  verificationCode: "verificationCode",
  invalidVerificationCode: "invalidVerificationCode",
  reauthenticate: "reauthenticate",
  reauthenticateText: "reauthenticateText",
  continue: "continue",
  verifyEmail: "verifyEmail",
  ok: "ok",
  verifyYourEmail: "verifyYourEmail",
  phoneNumberUsedInAnotherAccount: "phoneNumberUsedInAnotherAccount",
  resetPassword: "resetPassword",
  typeNewPassword: "typeNewPassword",
  unexpectedError: "unexpectedError",
  recoverEmail: "recoverEmail",
  recoveredEmail: "recoveredEmail",
  emailVerification: "emailVerification",
  emailVerified: "emailVerified",
  selected: "selected",
  select: "select",
  updateProfileInfo: "updateProfileInfo",
  profileUpdate: "profileUpdate",
  allLabels: "allLabels",
  noBoard: "noBoard",
  logout: "logout",
  deleteBoard: "deleteBoard",
  deleteBoardWarning: "deleteBoardWarning",
  deletingDeals: "deletingDeals",
  deletingDealProgress: "deletingDealProgress",
  changeName: "changeName",
  description: "description",
  date: "date",
  media: "media",
  action: "action",
  spam: "spam",
  staySignedIn: "staySignedIn",
  permissions: "permissions",
  showOnlyAssignedCards: "showOnlyAssignedCards",
  billingOverview: "billingOverview",
  billingPaymentHistory: "billingPaymentHistory",
  billingRecurringItems: "billingRecurringItems",
  billingPaymentSettings: "billingPaymentSettings",
  billingPrefrences: "billingPrefrences",
  currentBalance: "currentBalance",
  addFunds: "addFunds",
  autoRecharge: "autoRecharge",
  changePlan: "changePlan",
  inActive: "inActive",
  paymentMethod: "paymentMethod",
  amount: "amount",
  paymentHistory: "paymentHistory",
  addon: "addon",
  usageSummary: "usageSummary",
  balance: "balance",
  paymentAmount: "paymentAmount",
  newBalance: "newBalance",
  addFundsDescription: "addFundsDescription",
  addFundsMinMaxAmount: "addFundsMinMaxAmount",
  selectPaymentMethod: "selectPaymentMethod",
  addNewPaymentMethod: "addNewPaymentMethod",
  addToMyBalance: "addToMyBalance",
  overview: "overview",
  type: "type",
  status: "status",
  totalThisMonth: "totalThisMonth",
  allBillingDateAndTimesAreInUTC: "allBillingDateAndTimesAreInUTC",
  paymentSetting: "paymentSetting",
  expiryDate: "expiryDate",
  number: "number",
  default: "default",
  makeDefault: "makeDefault",
  cardHolderName: "cardHolderName",
  billingAddress: "billingAddress",
  country: "country",
  address1: "address1",
  address2: "address2",
  city: "city",
  state: "state",
  zip: "zip",
  autoRechargeDescription: "autoRechargeDescription",
  whenBalanceGoesDownBelow: "whenBalanceGoesDownBelow",
  bringMyBalanceBackUpTo: "bringMyBalanceBackUpTo",
  addFundsForExample: "addFundsForExample",
  usingThisPrimaryMethod: "usingThisPrimaryMethod",
  onlyPaymentMethodAvailableShowHere: "onlyPaymentMethodAvailableShowHere",
  enableAutoRecharge: "enableAutoRecharge",
  company: "company",
  billingPrefrencesDescription: "billingPrefrencesDescription",
  generalDetails: "generalDetails",
  companyName: "companyName",
  poNumber: "poNumber",
  serviceAddress: "serviceAddress",
  location: "location",
  attentionTo: "attentionTo",
  streetAddress: "streetAddress",
  address: "address",
  street: "street",
  province: "province",
  postalCode: "postalCode",
  businessTaxID: "businessTaxID",
  iHaveABusinessTaxID: "iHaveABusinessTaxID",
  title: "title",
  invoiceList: "invoiceList",
  plans: "plans",
  addons: "addons",
  addonsDescription: "addonsDescription",
  estimatedCost: "estimatedCost",
  update: "update",
  subscribe: "subscribe",
  subscribed: "subscribed",
  pro: "pro",
  starter: "starter",
  premium: "premium",
  item: "item",
  downgrade: "downgrade",
  downgradeConfirmation: "downgradeConfirmation",
  downgradeText1: "downgradeText1",
  downgradeText2: "downgradeText2",
  workspaceInvitation: "workspaceInvitation",
  clickToJoin: "clickToJoin",
  addUser: "addUser",
  clickToGenerateURL: "clickToGenerateURL",
  copyURL: "copyURL",
  urlCopied: "urlCopied",
  invitationURL: "invitationURL",
  helpCenter: "helpCenter",
  allArticles: "allArticles",
  published: "published",
  draft: "draft",
  collections: "collections",
  helpCenterSettings: "helpCenterSettings",
  lastEditied: "lastEditied",
  hideFilter: "hideFilter",
  addFilter: "addFilter",
  newArticle: "newArticle",
  filter: "filter",
  noArticlesMatch: "noArticlesMatch",
  resetYourFilters: "resetYourFilters",
  resetFilters: "resetFilters",
  publish: "publish",
  selectLanguage: "selectLanguage",
  selectCollection: "selectCollection",
  noOfArticles: "noOfArticles",
  addCollection: "addCollection",
  editCollection: "editCollection",
  content: "content",
  styling: "styling",
  pageTitle: "pageTitle",
  english: "english",
  linkToYourHomepage: "linkToYourHomepage",
  header: "header",
  welcomeMessage: "welcomeMessage",
  color: "color",
  primaryColor: "primaryColor",
  secondaryColor: "secondaryColor",
  webChat: "webChat",
  customizeWebchat: "customizeWebchat",
  botName: "botName",
  bubbleMessage: "bubbleMessage",
  botIconUrl: "botIconUrl",
  replySoonText: "replySoonText",
  typingEnabled: "typingEnabled",
  clearConversationEnabled: "clearConversationEnabled",
  webWidgetLabel: "webWidgetLabel",
  greetings: "greetings",
  headerText: "headerText",
  headerDescription: "headerDescription",
  welcomeText: "welcomeText",
  greetingsDialog: "greetingsDialog",
  faqs: "faqs",
  faqText: "faqText",
  popularQueries: "popularQueries",
  contentCard: "contentCard",
  enabled: "enabled",
  cardId: "cardId",
  cardText: "cardText",
  linkCard: "linkCard",
  cardUrl: "cardUrl",
  webChatSaveMessage: "webChatSaveMessage",
  webChatCopiedMessage: "webChatCopiedMessage",
  sent: "sent",
  delivered: "delivered",
  read: "read",
  deliveryRate: "deliveryRate",
  readRate: "readRate",
  failed: "failed",
  noOpen: "noOpen",
  dtr: "dtr",
  more: "more",
  scheduled: "scheduled",
  ended: "ended",
  campaignStats: "campaignStats",
  waMessageTemplate: "waMessageTemplate",
  waMessageTemplateDescription: "waMessageTemplateDescription",
  learnMoreAboutTemplates: "learnMoreAboutTemplates",
  noWaTemplates: "noWaTemplates",
  newWaMessageTemplate: "newWaMessageTemplate",
  templateName: "templateName",
  messageBody: "messageBody",
  messageLanguage: "messageLanguage",
  messageBodyCopied: "messageBodyCopied",
  submitNewWaTemplate: "submitNewWaTemplate",
  newWaMessageTemplateDescription: "newWaMessageTemplateDescription",
  generalInformation: "generalInformation",
  templateNameHelpText: "templateNameHelpText",
  templateCategory: "templateCategory",
  templateCategoryHelpText: "templateCategoryHelpText",
  messageTemplate: "messageTemplate",
  messageTemplateDescription: "messageTemplateDescription",
  messageTemplateLearnMore: "messageTemplateLearnMore",
  messageBodyLabel: "messageBodyLabel",
  messageBodyDescription: "messageBodyDescription",
  messageBodyLearnMore: "messageBodyLearnMore",
  buttonOptional: "buttonOptional",
  buttonText: "buttonText",
  value: "value",
  typeOfAction: "typeOfAction",
  saveWaTemplate: "saveWaTemplate",
  waTemplateCreated: "waTemplateCreated",
  waTemplateStatusChanged: "waTemplateStatusChanged",
  messageTemplates: "messageTemplates",
  updateStatus: "updateStatus",
  statusLogs: "statusLogs",
  logsNotFound: "logsNotFound",
  changedTo: "changedTo",
  statusUpdated: "statusUpdated",
  snoozed: "snoozed",
  noMyQueueChats: "noMyQueueChats",
  noSnoozedChats: "noSnoozedChats",
  inactivityDialog: "inactivityDialog",
  inactivityDialogAt: "inactivityDialogAt",
  minutes: "minutes",
  updatedAt: "updatedAt",
  question: "question",
  answer: "answer",
  addFAQ: "addFAQ",
  editFAQ: "editFAQ",
  noFAQs: "noFAQs",
  importContact: "importContact",
  noContacts: "noContacts",
  contactsImportSuccess: "contactsImportSuccess",
  catalogs: "catalogs",
  importCatalog: "importCatalog",
  catalogSetting: "catalogSetting",
  support: "support",
  engage: "engage",
  convert: "convert",
  preferences: "preferences",
  enableAutomaticChatAcceptance: "enableAutomaticChatAcceptance",
  targetAudienceCountry: "targetAudienceCountry",
  templateType: "templateType",
  deleteTemplate: "deleteTemplate",
  waTemplateDeleted: "waTemplateDeleted",
  gettingStarted: "gettingStarted",
  setupWelcomeEdna: "setupWelcomeEdna",
  setupLetGetSetup: "setupLetGetSetup",
  setupDescription: "setupDescription",
  getSetup: "getSetup",
  needHelp: "needHelp",
  setupInboxTitle: "setupInboxTitle",
  setupInboxMessengerTitle: "setupInboxMessengerTitle",
  setupInboxMessengerDescription: "setupInboxMessengerDescription",
  setupInboxInstagramTitle: "setupInboxInstagramTitle",
  setupInboxInstagramDescription: "setupInboxInstagramDescription",
  setupInboxInstagramDescription1: "setupInboxInstagramDescription1",
  setupInboxInstagramDescription2: "setupInboxInstagramDescription2",
  setupInboxInstagramDescription3: "setupInboxInstagramDescription3",
  setupInboxInstagramDescription4: "setupInboxInstagramDescription4",
  setupInboxWhatsAppTitle: "setupInboxWhatsAppTitle",
  setupInboxWhatsAppDescription: "setupInboxWhatsAppDescription",
  setupInboxTelegramTitle: "setupInboxTelegramTitle",
  setupInboxTelegramDescription: "setupInboxTelegramDescription",
  setupInboxMSTeamsTitle: "setupInboxMSTeamsTitle",
  setupInboxMSTeamsDescription: "setupInboxMSTeamsDescription",
  setupInboxWebchatTitle: "setupInboxWebchatTitle",
  setupInboxWebchatDescription: "setupInboxWebchatDescription",
  setupInboxCallTitle: "setupInboxCallTitle",
  setupInboxCallDescription: "setupInboxCallDescription",
  setupHelpCenterTitle: "setupHelpCenterTitle",
  setupHelpCenterCollectionTitle: "setupHelpCenterCollectionTitle",
  setupHelpCenterCollectionDescription: "setupHelpCenterCollectionDescription",
  setupHelpCenterFAQTitle: "setupHelpCenterFAQTitle",
  setupHelpCenterFAQDescription: "setupHelpCenterFAQDescription",
  setupHelpCenterCatalogTitle: "setupHelpCenterCatalogTitle",
  setupHelpCenterCatalogDescription: "setupHelpCenterCatalogDescription",
  setupGenAITitle: "setupGenAITitle",
  setupGenAIConfigureTitle: "setupGenAIConfigureTitle",
  setupGenAIConfigureDescription: "setupGenAIConfigureDescription",
  setupGenAIPromptTitle: "setupGenAIPromptTitle",
  setupGenAIPromptDescription: "setupGenAIPromptDescription",
  setupSettingsTitle: "setupSettingsTitle",
  setupSettingsSupportTitle: "setupSettingsSupportTitle",
  setupCommerceTitle: "setupCommerceTitle",
  setupIntegrationsTitle: "setupIntegrationsTitle",
  setupSettingsSupportDescription: "setupSettingsSupportDescription",
  setupSettingsNPSTitle: "setupSettingsNPSTitle",
  setupSettingsNPSDescription: "setupSettingsNPSDescription",
  setupSettingsChatAssignmentTitle: "setupSettingsChatAssignmentTitle",
  setupSettingsChatAssignmentDescription:
    "setupSettingsChatAssignmentDescription",
  setupUpdatedSuccessfully: "setupUpdatedSuccessfully",
  scheduledChatClosingDialogType: "scheduledChatClosingDialogType",
  teams: "teams",
  chatAssignmentType: "chatAssignmentType",
  autoAssignChatUserTypes: "autoAssignChatUserTypes",
  roundRobinPerCardDescription: "roundRobinPerCardDescription",
  liveChatCardUnavailable: "liveChatCardUnavailable",
  tasks: "tasks",
  dueDate: "dueDate",
  editAvatar: "editAvatar",
  teammates: "teammates",
  groupChats: "groupChats",
  contactInformation: "contactInformation",
  aboutMe: "aboutMe",
  members: "members",
  orgKnowledge: "orgKnowledge",
  searchFolder: "searchFolder",
  noFolders: "noFolders",
  noDocuments: "noDocuments",
  createDocuments: "createDocuments",
  createDocumentsDescription: "createDocumentsDescription",
  storedDocuments: "storedDocuments",
  storedDocumentsDescription: "storedDocumentsDescription",
  write: "write",
  writeDescription: "writeDescription",
  upload: "upload",
  uploadDescription: "uploadDescription",
  importWebsite: "importWebsite",
  importWebsiteDescription: "importWebsiteDescription",
  source: "source",
  lastTrainedAt: "lastTrainedAt",
  comingSoon: "comingSoon",
  createFolder: "createFolder",
  editFolder: "editFolder",
  options: "options",
  transfer: "transfer",
  transferDocuments: "transferDocuments",
  transferDocumentsDescription: "transferDocumentsDescription",
  sourceWorkspace: "sourceWorkspace",
  sourceFolder: "sourceFolder",
  targetWorkspace: "targetWorkspace",
  targetFolder: "targetFolder",
  selectWorkspace: "selectWorkspace",
  selectFolder: "selectFolder",
  noFoldersInTargetWorkspace: "noFoldersInTargetWorkspace",
  transferSummary: "transferSummary",
  documentsToTransfer: "documentsToTransfer",
  errorLoadingWorkspaces: "errorLoadingWorkspaces",
  errorLoadingFolders: "errorLoadingFolders",
  pleaseSelectWorkspaceAndFolder: "pleaseSelectWorkspaceAndFolder",
  documentsTransferredSuccessfully: "documentsTransferredSuccessfully",
  errorTransferringDocuments: "errorTransferringDocuments",
  transferFAQs: "transferFAQs",
  transferFAQsDescription: "transferFAQsDescription",
  faqsToTransfer: "faqsToTransfer",
  faqsTransferredSuccessfully: "faqsTransferredSuccessfully",
  errorTransferringFAQs: "errorTransferringFAQs",
  pleaseSelectWorkspace: "pleaseSelectWorkspace",
  transferCollections: "transferCollections",
  transferCollectionsDescription: "transferCollectionsDescription",
  collectionsToTransfer: "collectionsToTransfer",
  articlesWillBeTransferred: "articlesWillBeTransferred",
  collectionsTransferredSuccessfully: "collectionsTransferredSuccessfully",
  errorTransferringCollections: "errorTransferringCollections",
  transferArticles: "transferArticles",
  transferArticlesDescription: "transferArticlesDescription",
  articlesToTransfer: "articlesToTransfer",
  selectTargetCollection: "selectTargetCollection",
  noCollectionsInTargetWorkspace: "noCollectionsInTargetWorkspace",
  articlesTransferredSuccessfully: "articlesTransferredSuccessfully",
  errorTransferringArticles: "errorTransferringArticles",
  ednaBot: "ednaBot",
  knowledge: "knowledge",
  configureEdnaBotsKnowledge: "configureEdnaBotsKnowledge",
  configureEdnaBotsKnowledgeDescription:
    "configureEdnaBotsKnowledgeDescription",
  activateEdnaBot: "activateEdnaBot",
  activateEdnaBotDescription: "activateEdnaBotDescription",
  enableEdnaBot: "enableEdnaBot",
  selectEdnaBotKnowledge: "selectEdnaBotKnowledge",
  aITeams: "aITeams",
  aITeamsChat: "aITeamsChat",
  noAITeams: "noAITeams",
  searchAITeam: "searchAITeam",
  createAITeam: "createAITeam",
  editAITeam: "editAITeam",
  function: "function",
  agents: "agents",
  proxyAgent: "proxyAgent",
  addedBy: "addedBy",
  org: "org",
  nonBusinessHour: "nonBusinessHour",
  aITeamChart: "aITeamChart",
  seePastTasks: "seePastTasks",
  aITeamPastTasks: "aITeamPastTasks",
  taskName: "taskName",
  replay: "replay",
  taskReplay: "taskReplay",
  noTasks: "noTasks",
  proxy: "proxy",
  canViewAllContacts: "canViewAllContacts",
  enableAutoLeadCollector: "enableAutoLeadCollector",
  autoLeadCollector: "autoLeadCollector",
  embeddingStatus: "embeddingStatus",
  lastEmbeddidAt: "lastEmbeddidAt",
  deactivateUser: "deactivateUser",
  satisfaction: "satisfaction",
  taskStatusTodo: "taskStatusTodo",
  taskStatusInProgress: "taskStatusInProgress",
  taskStatusDone: "taskStatusDone",
  repeat: "repeat",
  every: "every",
  queuePositionEnabled: "queuePositionEnabled",
  queuePositionDialog: "queuePositionDialog",
  errorLogs: "errorLogs",
  error: "error",
  errorLogPreview: "errorLogPreview",
  stackTrace: "stackTrace",
  viewOnlyAccess: "viewOnlyAccess",
  enableInactivityDialog: "enableInactivityDialog",
  inactivityDialogType: "inactivityDialogType",
  attachments: "attachments",
  uploadAttachmentText: "uploadAttachmentText",
  logoUrl: "logoUrl",
  popularArticles: "popularArticles",
  homepageConfig: "homepageConfig",
  footer: "footer",
  gotoUrlEnabled: "gotoUrlEnabled",
  gotoUrlText: "gotoUrlText",
  gotoUrl: "gotoUrl",
  communityUrlEnabled: "communityUrlEnabled",
  communityUrlText: "communityUrlText",
  communityUrl: "communityUrl",
  academyUrlEnabled: "academyUrlEnabled",
  academyUrlText: "academyUrlText",
  academyUrl: "academyUrl",
  commerce: "commerce",
  commerceBranches: "commerceBranches",
  commerceProducts: "commerceProducts",
  commerceProfile: "commerceProfile",
  gotoShopUrl: "gotoShopUrl",
  notFound: "notFound",
  signUpWelcome: "signUpWelcome",
  signOut: "signOut",
  restaurants: "restaurants",
  userLoggedIn: "userLoggedIn",
  userFound: "userFound",
  emailAlreadyInUse: "emailAlreadyInUse",
  weakPassword: "weakPassword",
  userCreated: "userCreated",
  recoveryEmailSent: "recoveryEmailSent",
  verificationEmailSent: "verificationEmailSent",
  emailNotVerified: "emailNotVerified",
  requiredField: "requiredField",
  invalidField: "invalidField",
  requiresRecentLogin: "requiresRecentLogin",
  updateSucceeded: "updateSucceeded",
  logo: "logo",
  orders: "orders",
  menu: "menu",
  branchMenu: "branchMenu",
  restaurantProfile: "restaurantProfile",
  branchProfile: "branchProfile",
  console: "console",
  coupons: "coupons",
  code: "code",
  discount: "discount",
  preparationTime: "preparationTime",
  contactEmails: "contactEmails",
  contactPhones: "contactPhones",
  notificationPhones: "notificationPhones",
  botGreetingMessage: "botGreetingMessage",
  branches: "branches",
  cash: "cash",
  creditCard: "creditCard",
  express: "express",
  inRestaurant: "inRestaurant",
  pickUp: "pickUp",
  time: "time",
  zone: "zone",
  paymentMethods: "paymentMethods",
  deliveryTypes: "deliveryTypes",
  deliveryCoverage: "deliveryCoverage",
  deliveryCoverageType: "deliveryCoverageType",
  currency: "currency",
  image: "image",
  minimumSelectedItems: "minimumSelectedItems",
  maximumSelectedItems: "maximumSelectedItems",
  perProduct: "perProduct",
  minimumValidation: "minimumValidation",
  maximumValidation: "maximumValidation",
  isModifierRequired: "isModifierRequired",
  modifierItems: "modifierItems",
  menuModifiers: "menuModifiers",
  menuCategories: "menuCategories",
  menuInternalCode: "menuInternalCode",
  menuItems: "menuItems",
  addMenuCategory: "addMenuCategory",
  onlyPositiveValues: "onlyPositiveValues",
  addMenuItem: "addMenuItem",
  addMenuModifier: "addMenuModifier",
  isRequired: "isRequired",
  isOptional: "isOptional",
  isExcluded: "isExcluded",
  min: "min",
  max: "max",
  exclude: "exclude",
  excludeItems: "excludeItems",
  include: "include",
  includeAll: "includeAll",
  excluded: "excluded",
  included: "included",
  otherPaymentMethod: "otherPaymentMethod",
  otherPaymentMethodName: "otherPaymentMethodName",
  otherPaymentMethodImage: "otherPaymentMethodImage",
  otherPaymentMethodDescription: "otherPaymentMethodDescription",
  items: "items",
  ordersRequests: "ordersRequests",
  readyForDelivery: "readyForDelivery",
  beingPrepared: "beingPrepared",
  deliveryZone: "deliveryZone",
  deliveryAddress: "deliveryAddress",
  referencePhone: "referencePhone",
  deliveryName: "deliveryName",
  deliveryNameTable: "deliveryNameTable",
  deliveryType: "deliveryType",
  order: "order",
  prepare: "prepare",
  prepareAll: "prepareAll",
  toolTipPrepareAll: "toolTipPrepareAll",
  modalTitlePrepareAll: "modalTitlePrepareAll",
  sendToDeliveryAll: "sendToDeliveryAll",
  toolTipSendToDeliveryAll: "toolTipSendToDeliveryAll",
  modalTitleSendToDeliveryAll: "modalTitleSendToDeliveryAll",
  deliveryCompleteAll: "deliveryCompleteAll",
  toolTipDeliveryCompleteAll: "toolTipDeliveryCompleteAll",
  disableNotifications: "disableNotifications",
  modalTitleDeliveryCompleteAll: "modalTitleDeliveryCompleteAll",
  disableNotificationsTT: "disableNotificationsTT",
  disableOrderTrackingTT: "disableOrderTrackingTT",
  disableOrderTracking: "disableOrderTracking",
  disableEstimateDeliveryTime: "disableEstimateDeliveryTime",
  disableEstimateDeliveryTimeTT: "disableEstimateDeliveryTimeTT",
  note: "note",
  channelInfo: "channelInfo",
  createOrder: "createOrder",
  activeOrders: "activeOrders",
  finishedOrders: "finishedOrders",
  webAdmin: "webAdmin",
  admin: "admin",
  messenger: "messenger",
  whatsApp: "whatsApp",
  cancellationReason: "cancellationReason",
  cancelOrder: "cancelOrder",
  basic: "basic",
  free: "free",
  promoCodes: "promoCodes",
  plus: "plus",
  branch: "branch",
  loading: "loading",
  couponCode: "couponCode",
  appliedCoupon: "appliedCoupon",
  subtotal: "subtotal",
  invalidPhoneNumber: "invalidPhoneNumber",
  categoryAlreadyExists: "categoryAlreadyExists",
  deactivate: "deactivate",
  askDeactivateConfirmation: "askDeactivateConfirmation",
  activate: "activate",
  askActivateConfirmation: "askActivateConfirmation",
  nothingHereYet: "nothingHereYet",
  deliveryTime: "deliveryTime",
  changesReceivedWillBeAppliedSoon: "changesReceivedWillBeAppliedSoon",
  askExcludeConfirmation: "askExcludeConfirmation",
  askIncludeConfirmation: "askIncludeConfirmation",
  arrivalTime: "arrivalTime",
  arrivalTimeReady: "arrivalTimeReady",
  arrivalMinutes: "arrivalMinutes",
  addMoreToReachMinimum: "addMoreToReachMinimum",
  orderId: "orderId",
  noDuplicates: "noDuplicates",
  orderIsAlreadySent: "orderIsAlreadySent",
  youCancelledThisOrder: "youCancelledThisOrder",
  restaurantName: "restaurantName",
  branchName: "branchName",
  textIsTooLong: "textIsTooLong",
  mustBeEqualOrGreaterThanMinimum: "mustBeEqualOrGreaterThanMinimum",
  managers: "managers",
  invalidCoupon: "invalidCoupon",
  upgradePlan: "upgradePlan",
  currentPlanUpgrade: "currentPlanUpgrade",
  basicPlanDescription: "basicPlanDescription",
  proPlanDescription: "proPlanDescription",
  plusPlanDescription: "plusPlanDescription",
  contactUs: "contactUs",
  willSendToUser: "willSendToUser",
  needAtLeastOneBranch: "needAtLeastOneBranch",
  plan: "plan",
  allowedBranches: "allowedBranches",
  youHaveBeenUpgraded: "youHaveBeenUpgraded",
  includesPreparationTime: "includesPreparationTime",
  facebookUrl: "facebookUrl",
  updatePaymentMethod: "updatePaymentMethod",
  proFeature: "proFeature",
  agreePlanUpdate: "agreePlanUpdate",
  cuisine: "cuisine",
  cuisines: {
    africanEthiopian: "cuisines.africanEthiopian",
    africanOther: "cuisines.africanOther",
    alcohol: "cuisines.alcohol",
    american: "cuisines.american",
    argentinian: "cuisines.argentinian",
    asianFusion: "cuisines.asianFusion",
    asianOther: "cuisines.asianOther",
    bbq: "cuisines.bbq",
    bakery: "cuisines.bakery",
    barOrPubFood: "cuisines.barOrPubFood",
    brazilian: "cuisines.brazilian",
    breakfastAndBrunch: "cuisines.breakfastAndBrunch",
    bubbleTea: "cuisines.bubbleTea",
    burgers: "cuisines.burgers",
    burmese: "cuisines.burmese",
    cajunOrCreole: "cuisines.cajunOrCreole",
    caribbean: "cuisines.caribbean",
    chicken: "cuisines.chicken",
    chilean: "cuisines.chilean",
    chineseCantonese: "cuisines.chineseCantonese",
    chineseHotPot: "cuisines.chineseHotPot",
    chineseNoodlesAndDumplings: "cuisines.chineseNoodlesAndDumplings",
    chineseOther: "cuisines.chineseOther",
    chineseSichuan: "cuisines.chineseSichuan",
    chineseTaiwanese: "cuisines.chineseTaiwanese",
    coffeeAndTea: "cuisines.coffeeAndTea",
    colombian: "cuisines.colombian",
    comfortFood: "cuisines.comfortFood",
    dessertOther: "cuisines.dessertOther",
    europeanOther: "cuisines.europeanOther",
    fishAndChips: "cuisines.fishAndChips",
    french: "cuisines.french",
    georgian: "cuisines.georgian",
    german: "cuisines.german",
    gourmet: "cuisines.gourmet",
    halal: "cuisines.halal",
    healthy: "cuisines.healthy",
    iceCreamAndFrozenYogurt: "cuisines.iceCreamAndFrozenYogurt",
    indian: "cuisines.indian",
    indonesian: "cuisines.indonesian",
    italian: "cuisines.italian",
    japaneseOther: "cuisines.japaneseOther",
    japaneseRamen: "cuisines.japaneseRamen",
    japaneseSushi: "cuisines.japaneseSushi",
    juiceAndSmoothies: "cuisines.juiceAndSmoothies",
    korean: "cuisines.korean",
    kosher: "cuisines.kosher",
    latinAmericanOther: "cuisines.latinAmericanOther",
    malaysian: "cuisines.malaysian",
    mediterranean: "cuisines.mediterranean",
    mexican: "cuisines.mexican",
    middleEastern: "cuisines.middleEastern",
    modernAustralian: "cuisines.modernAustralian",
    other: "cuisines.other",
    peruvian: "cuisines.peruvian",
    pizza: "cuisines.pizza",
    russian: "cuisines.russian",
    saladOrSandwiches: "cuisines.saladOrSandwiches",
    seafood: "cuisines.seafood",
    snacks: "cuisines.snacks",
    soulFood: "cuisines.soulFood",
    southern: "cuisines.southern",
    spanish: "cuisines.spanish",
    steakhouse: "cuisines.steakhouse",
    thai: "cuisines.thai",
    vegetarianOrVegan: "cuisines.vegetarianOrVegan",
    vietnamese: "cuisines.vietnamese",
    wings: "cuisines.wings",
  },
  continueWithFacebook: "continueWithFacebook",
  facebookPage: "facebookPage",
  needsAccountLinking: "needsAccountLinking",
  needsAccountCreation: "needsAccountCreation",
  facebookPermissionsDisclaimer: "facebookPermissionsDisclaimer",
  signInWithFacebookTitle: "signInWithFacebookTitle",
  botNameToolTip: "botNameToolTip",
  greetingToolTip: "greetingToolTip",
  listToolTip: "listToolTip",
  preparationTimeToolTip: "preparationTimeToolTip",
  deliveryCoverageToolTip: "deliveryCoverageToolTip",
  inRestaurantTypes: "inRestaurantTypes",
  stopSound: "stopSound",
  typeAddress: "typeAddress",
  selectPlaceOnMap: "selectPlaceOnMap",
  markBuildingEntranceForDelivery: "markBuildingEntranceForDelivery",
  deliveryNotes: "deliveryNotes",
  highestPrice: "highestPrice",
  minimumProductQty: "minimumProductQty",
  promotionType: "promotionType",
  isPromotional: "isPromotional",
  promotionParameter: "promotionParameter",
  makeSureFirstValueIsHigher: "makeSureFirstValueIsHigher",
  outOfDeliveryCoverage: "outOfDeliveryCoverage",
  unknown: "unknown",
  distance: "distance",
  export: "export",
  creating: "creating",
  received: "received",
  preparing: "preparing",
  awaitingDelivery: "awaitingDelivery",
  canceledByUser: "canceledByUser",
  freeDelivery: "freeDelivery",
  freeDeliveryOnMinItemsQuantity: "freeDeliveryOnMinItemsQuantity",
  minimumProduct: "minimumProduct",
  minimumProductError: "minimumProductError",
  branchClickHere: "branchClickHere",
  howToDocument: "howToDocument",
  ednaPayLink: "ednaPayLink",
  ednaPayLinkLong: "ednaPayLinkLong",
  verifiedAccount: "verifiedAccount",
  verifiedAccountToolTip: "verifiedAccountToolTip",
  verifiedBusiness: "verifiedBusiness",
  verifiedBusinessToolTip: "verifiedBusinessToolTip",
  verifiedEmail: "verifiedEmail",
  verifiedEmailToolTip: "verifiedEmailToolTip",
  verifiedPhone: "verifiedPhone",
  verifiedPhoneToolTip: "verifiedPhoneToolTip",
  verifiedKYC: "verifiedKYC",
  verifiedKYCToolTip: "verifiedKYCToolTip",
  createAccount: "createAccount",
  disabledEdnaPay: "disabledEdnaPay",
  ednaPay: "ednaPay",
  refresh: "refresh",
  ednaPayLinked: "ednaPayLinked",
  validatingPayment: "validatingPayment",
  paymentCompleted: "paymentCompleted",
  verifiedTermsAndConditions: "verifiedTermsAndConditions",
  refreshing: "refreshing",
  txAmount: "txAmount",
  txId: "txId",
  txfee: "txfee",
  conectEdnaPayAccount: "conectEdnaPayAccount",
  howToFix: "howToFix",
  payVerificationText: "payVerificationText",
  orderingSelectBranch: "orderingSelectBranch",
  selectBranch: "selectBranch",
  orderingBranchSelected: "orderingBranchSelected",
  you: "you",
  letsGo: "letsGo",
  generatePay: "generatePay",
  finishOrder: "finishOrder",
  subtotalSummary: "subtotalSummary",
  cancelledSummary: "cancelledSummary",
  expressPriceText: "expressPriceText",
  discountedSubtotalText: "discountedSubtotalText",
  paymentMethodInfo: "paymentMethodInfo",
  productAddedToCart: "productAddedToCart",
  orderClosing: "orderClosing",
  orderClosingAfterCancelled: "orderClosingAfterCancelled",
  orderButton: "orderButton",
  orderButtonNoTracking: "orderButtonNoTracking",
  timeDelivery: "timeDelivery",
  orderDetails: "orderDetails",
  deliveryFee: "deliveryFee",
  deleteProduct: "deleteProduct",
  addItem: "addItem",
  viewProfile: "viewProfile",
  branchesOf: "branchesOf",
  minimumSelectedModifiers: "minimumSelectedModifiers",
  maximumSelectedModifiers: "maximumSelectedModifiers",
  emptyCart: "emptyCart",
  descriptionTime: "descriptionTime",
  arrivalTimeValidation: "arrivalTimeValidation",
  groupByCategories: "groupByCategories",
  integrations: "integrations",
  deliveryIntegration: "deliveryIntegration",
  paymentIntegration: "paymentIntegration",
  hubIntegration: "hubIntegration",
  notAvailableOnYourCountryOrIntegrationDependency:
    "notAvailableOnYourCountryOrIntegrationDependency",
  storeId: "storeId",
  integrationsPro: "integrationsPro",
  trackYourOrder: "trackYourOrder",
  orderNotFound: "orderNotFound",
  orderingOrTracking: "orderingOrTracking",
  ordering: "ordering",
  trackOrder: "trackOrder",
  primaryColorTooltip: "primaryColorTooltip",
  secondaryColorTooltip: "secondaryColorTooltip",
  chooseColor: "chooseColor",
  useCurrentLocation: "useCurrentLocation",
  orderingBranchClosed: "orderingBranchClosed",
  viewInvoices: "viewInvoices",
  viewInvoice: "viewInvoice",
  invoices: "invoices",
  enjoyLoyalty: "enjoyLoyalty",
  loyaltyIntegration: "loyaltyIntegration",
  customerId: "customerId",
  customerIdPlaceHolder: "customerIdPlaceHolder",
  enjoyLoyaltyFailure: "enjoyLoyaltyFailure",
  ednaPayAdvertise: "ednaPayAdvertise",
  ednaPayAdvertiseCost: "ednaPayAdvertiseCost",
  chathubId: "chathubId",
  chathubKey: "chathubKey",
  chathubPassword: "chathubPassword",
  chathubStory: "chathubStory",
  chatBotIntegration: "chatBotIntegration",
  newOrderReceived: "newOrderReceived",
  goToClientPortal: "goToClientPortal",
  created: "created",
  updated: "updated",
  pixelId: "pixelId",
  onItsWay: "onItsWay",
  readyForPickUp: "readyForPickUp",
  readyToServe: "readyToServe",
  creditCardChargeAnowledge: "creditCardChargeAnowledge",
  parentCategory: "parentCategory",
  uiMode: "uiMode",
  compact: "compact",
  expanded: "expanded",
  seeMore: "seeMore",
  featured: "featured",
  disableBranchProductExclusionTT: "disableBranchProductExclusionTT",
  disableBranchProductExclusion: "disableBranchProductExclusion",
  showBanner: "showBanner",
  bannerImage: "bannerImage",
  hasSchedule: "hasSchedule",
  preview: "preview",
  endsIn: "endsIn",
  promotionHasEnded: "promotionHasEnded",
  emailTemplates: "emailTemplates",
  noEmailTemplates: "noEmailTemplates",
  emailTemplateCreatedMessage: "emailTemplateCreatedMessage",
  emailTemplateUpdatedMessage: "emailTemplateUpdatedMessage",
  workflows: "workflows",
  searchWorkflowCategory: "searchWorkflowCategory",
  noWorkflowCategories: "noWorkflowCategories",
  createWorkflowCategory: "createWorkflowCategory",
  editWorkflowCategory: "editWorkflowCategory",
  createWorkflow: "createWorkflow",
  editWorkflow: "editWorkflow",
  automation: "automation",
  noWorkflows: "noWorkflows",
  isActive: "isActive",
  workflowName: "workflowName",
  createdBy: "createdBy",
  subject: "subject",
  daily: "daily",
  weekly: "weekly",
  monthly: "monthly",
  yearly: "yearly",
  autoAssignRequestOnNextDay: "autoAssignRequestOnNextDay",
  priority: "priority",
  high: "high",
  medium: "medium",
  low: "low",
  popularQueryType: "popularQueryType",
  popularFaqs: "popularFaqs",
  ednaBotIdCopied: "ednaBotIdCopied",
  manageKpi: "manageKpi",
  kpiName: "kpiName",
  target: "target",
  delta: "delta",
  deltaPercentage: "deltaPercentage",
  noKpis: "noKpis",
  addKpi: "addKpi",
  editKpi: "editKpi",
  createKpi: "createKpi",
  symbol: "symbol",
  createWorkspace: "createWorkspace",
  workspaceCreated: "workspaceCreated",
  popular: "popular",
  workspaces: "workspaces",
  workspaceProfile: "workspaceProfile",
  addNew: "addNew",
  workspaceBotWelcomeText: "workspaceBotWelcomeText",
  workspaceBotWelcome2Text: "workspaceBotWelcome2Text",
  workspaceBotComapanyText: "workspaceBotComapanyText",
  workspaceBotIndustryText: "workspaceBotIndustryText",
  workspaceBotTeamSizeText: "workspaceBotTeamSizeText",
  workspaceBotCreateWorkspaceText: "workspaceBotCreateWorkspaceText",
  functions: "functions",
  functionTitle: "functionTitle",
  functionDescription: "functionDescription",
  added: "added",
  addToWorkspace: "addToWorkspace",
  remove: "remove",
  aiSettings: "aiSettings",
  aiSettingsUpdated: "aiSettingsUpdated",
  industry: "industry",
  teamSize: "teamSize",
  workspaceProfileUpdated: "workspaceProfileUpdated",
  ednaBotSettings: "ednaBotSettings",
  ednaBotSettingsUpdated: "ednaBotSettingsUpdated",
  botIsConnectedWithAnotherWorkspace: "botIsConnectedWithAnotherWorkspace",
  isFunctionActive: "isFunctionActive",
  noActiveFunctionsFound: "noActiveFunctionsFound",
  businessFunction: "businessFunction",
  department: "department",
  assignUserToCurrentWorkspace: "assignUserToCurrentWorkspace",
  aITeamsSettings: "aITeamsSettings",
  aITeammates: "aITeammates",
  humanTeammates: "humanTeammates",
  operations: "operations",
  marketing: "marketing",
  sales: "sales",
  finance: "finance",
  hr: "hr",
  operationsDescription: "operationsDescription",
  marketingDescription: "marketingDescription",
  salesDescription: "salesDescription",
  financeDescription: "financeDescription",
  operationsFeatureInbox: "operationsFeatureInbox",
  operationsFeatureInboxDescription: "operationsFeatureInboxDescription",
  operationsFeatureSupport: "operationsFeatureSupport",
  operationsFeatureSupportDescription: "operationsFeatureSupportDescription",
  operationsFeatureEngagement: "operationsFeatureEngagement",
  operationsFeatureEngagementDescription:
    "operationsFeatureEngagementDescription",
  operationsFeatureConversion: "operationsFeatureConversion",
  operationsFeatureConversionDescription:
    "operationsFeatureConversionDescription",
  operationsFeatureCommerce: "operationsFeatureCommerce",
  operationsFeatureCommerceDescription: "operationsFeatureCommerceDescription",
  operationsFeatureWorkflows: "operationsFeatureWorkflows",
  operationsFeatureWorkflowsDescription:
    "operationsFeatureWorkflowsDescription",
  mkFeatureContentMarketing: "mkFeatureContentMarketing",
  mkFeatureContentMarketingDescription: "mkFeatureContentMarketingDescription",
  mkFeatureProductMarketing: "mkFeatureProductMarketing",
  mkFeatureProductMarketingDescription: "mkFeatureProductMarketingDescription",
  mkFeatureAcquisitionMarketing: "mkFeatureAcquisitionMarketing",
  mkFeatureAcquisitionMarketingDescription:
    "mkFeatureAcquisitionMarketingDescription",
  saFeatureSalesOperations: "saFeatureSalesOperations",
  saFeatureSalesOperationsDescription: "saFeatureSalesOperationsDescription",
  saFeatureSalesDevelopment: "saFeatureSalesDevelopment",
  saFeatureSalesDevelopmentDescription: "saFeatureSalesDevelopmentDescription",
  saFeatureSalesTraining: "saFeatureSalesTraining",
  saFeatureSalesTrainingDescription: "saFeatureSalesTrainingDescription",
  fnFeatureEPA: "fnFeatureEPA",
  fnFeatureEPADescription: "fnFeatureEPADescription",
  fnFeatureFinanceOperations: "fnFeatureFinanceOperations",
  fnFeatureFinanceOperationsDescription:
    "fnFeatureFinanceOperationsDescription",
  fnFeatureTaxation: "fnFeatureTaxation",
  fnFeatureTaxationDescription: "fnFeatureTaxationDescription",
  hrFeatureTalentAcquisition: "hrFeatureTalentAcquisition",
  hrFeatureTalentAcquisitionDescription:
    "hrFeatureTalentAcquisitionDescription",
  hrFeatureCompBenefits: "hrFeatureCompBenefits",
  hrFeatureCompBenefitsDescription: "hrFeatureCompBenefitsDescription",
  hrFeatureTraining: "hrFeatureTraining",
  hrFeatureTrainingDescription: "hrFeatureTrainingDescription",
  home: "home",
  utilizeItOnDesktop: "utilizeItOnDesktop",
  tickets: "tickets",
  addTicket: "addTicket",
  editTicket: "editTicket",
  list: "list",
  ticket: "ticket",
  task: "task",
  forwarderEmails: "forwarderEmails",
  mentions: "mentions",
  goToFuction: "goToFuction",
  configuration: "configuration",
  replyInThread: "replyInThread",
  thread: "thread",
  threads: "threads",
  countReply: "countReply",
  countReplies: "countReplies",
  opportunity: "opportunity",
  excludeAgents: "excludeAgents",
  calendar: "calendar",
  calendarSettings: "calendarSettings",
  eventDetails: "eventDetails",
  scheduleDetails: "scheduleDetails",
  myEvents: "myEvents",
  addEvent: "addEvent",
  share: "share",
  viewBookingPage: "viewBookingPage",
  group: "group",
  duration: "duration",
  editEvent: "editEvent",
  eventUpdated: "eventUpdated",
  schedulingDetails: "schedulingDetails",
  availableHours: "availableHours",
  bookingForm: "bookingForm",
  phone: "phone",
  calendarSettingsUpdated: "calendarSettingsUpdated",
  workspaceNotFound: "workspaceNotFound",
  booking: "booking",
  event: "event",
  selectDateAndTime: "selectDateAndTime",
  bookingSuccess: "bookingSuccess",
  archived: "archived",
  connectedText: "connectedText",
  bubbleVideoUrl: "bubbleVideoUrl",
  activity: "activity",
  hasMentionedYouIn: "hasMentionedYouIn",
  repliedInAThread: "repliedInAThread",
  noNotifications: "noNotifications",
  unreads: "unreads",
  connectedRate: "connectedRate",
  connectedChats: "connectedChats",
  linearConnectedRate: "linearConnectedRate",
  pending: "pending",
  approvedByWhatsapp: "approvedByWhatsapp",
  rejectedByWhatsapp: "rejectedByWhatsapp",
  designer: "designer",
  trigger: "trigger",
  workflowBuilder: "workflowBuilder",
  if: "if",
  and: "and",
  defaultFunction: "defaultFunction",
  events: "events",
  affiliate: "affiliate",
  startWithWorkspace: "startWithWorkspace",
  startWithWorkspaceDescription: "startWithWorkspaceDescription",
  createNewEdnaWorkspace: "createNewEdnaWorkspace",
  createNewEdnaWorkspaceDescription: "createNewEdnaWorkspaceDescription",
  enterWorkspaceId: "enterWorkspaceId",
  workspaceId: "workspaceId",
  lookingToCreateWorkspace: "lookingToCreateWorkspace",
  createNewWorkspace: "createNewWorkspace",
  findYourEdnaWorkspace: "findYourEdnaWorkspace",
  findYourEdnaWorkspaceDescription: "findYourEdnaWorkspaceDescription",
  workspaceJoinRequestSent: "workspaceJoinRequestSent",
  workspaceNoAccess: "workspaceNoAccess",
  pipeline: "pipeline",
  deal: "deal",
  estimatedCloseDate: "estimatedCloseDate",
  addDeal: "addDeal",
  stage: "stage",
  other: "other",
  probability: "probability",
  forecastCategory: "forecastCategory",
  openChat: "openChat",
  pipelineDashboard: "pipelineDashboard",
  openDeals: "openDeals",
  deals: "deals",
  closedWon: "closedWon",
  closedLost: "closedLost",
  forecastedRevenue: "forecastedRevenue",
  averageDealSize: "averageDealSize",
  average: "average",
  salesCycleLength: "salesCycleLength",
  newLeads: "newLeads",
  thisMonth: "thisMonth",
  wonRate: "wonRate",
  overall: "overall",
  salesPiplelineByAssingee: "salesPiplelineByAssingee",
  backToPipeline: "backToPipeline",
  closedAt: "closedAt",
  salesPipleline: "salesPipleline",
  sendToPipeline: "sendToPipeline",
  integration: "integration",
  createTicket: "createTicket",
  selectPage: "selectPage",
  createOrUpdateDeals: "createOrUpdateDeals",
  configureDialogFlow: "configureDialogFlow",
  setupDialogFlowDescription: "setupDialogFlowDescription",
  configureMetaCatalog: "configureMetaCatalog",
  setupMetaCatalogDescription: "setupMetaCatalogDescription",
  setupBuildCustomBot: "setupBuildCustomBot",
  setupCustomBotDescription: "setupCustomBotDescription",
  setupGenAIDescription: "setupGenAIDescription",
  conversationToday: "conversationToday",
  conversationsTodayAll: "conversationsTodayAll",
  conversationsTodayNew: "conversationsTodayNew",
  conversationsTodayFilter: "conversationsTodayFilter",
  pipelineBoard: "pipelineBoard",
  newConversationsLoadError: "newConversationsLoadError",
  newConversationFirstAdvisor: "newConversationFirstAdvisor",
  newConversationNotHandled: "newConversationNotHandled",
  newConversationWhatsappCampaign: "newConversationWhatsappCampaign",
  enableOrDisableFunction: "enableOrDisableFunction",
  guiddedTour: {
    addOperations: "guiddedTour.addOperations",
    enableFunction: "guiddedTour.enableFunction",
    configureFunction: "guiddedTour.configureFunction",
    featuresCompleted: "guiddedTour.featuresCompleted",
    activity: "guiddedTour.activity",
    dms: "guiddedTour.dms",
    inbox: "guiddedTour.inbox",
    helpCenter: "guiddedTour.helpCenter",
    chatBotSettings: "guiddedTour.chatBotSettings",
    businessSetting: "guiddedTour.businessSetting",
    workspaceProfile: "guiddedTour.workspaceProfile",
    opInbox: "guiddedTour.opInbox",
    opMyQueue: "guiddedTour.opMyQueue",
    opTeams: "guiddedTour.opTeams",
    opWorkflows: "guiddedTour.opWorkflows",
    opCrm: "guiddedTour.opCrm",
    opCampaigns: "guiddedTour.opCampaigns",
    opSales: "guiddedTour.opSales",
    opSettings: "guiddedTour.opSettings",
    calender: "guiddedTour.calender",
    calenderEvents: "guiddedTour.calenderEvents",
  },
  enable: "enable",
  disable: "disable",
  tour: "tour",
  provider: "provider",
  noIntegrations: "noIntegrations",
  pleaseSelectProvider: "pleaseSelectProvider",
  enableFacebookPageFirst: "enableFacebookPageFirst",
  editProfile: "editProfile",
  youHaveSelected: "youHaveSelected",
  contactHasActiveDeal: "contactHasActiveDeal",
  setupInboxEmailTitle: "setupInboxEmailTitle",
  setupInboxEmailDescription: "setupInboxEmailDescription",
  forwarderEmailsDescription: "forwarderEmailsDescription",
  smtp: "smtp",
  smtpConfigureDescription: "smtpConfigureDescription",
  imap: "imap",
  imapConfigureDescription: "imapConfigureDescription",
  quickReply: "quickReply",
  deadline: "deadline",
  allowConcurrentEvents: "allowConcurrentEvents",
  restrictLabelCreation: "restrictLabelCreation",
  restrictedLabelCreation: "restrictedLabelCreation",
  topDialogs: "topDialogs",
  topJourneys: "topJourneys",
  maxDateRangeIs2Months: "maxDateRangeIs2Months",
  noDialogsFound: "noDialogsFound",
  counts: "counts",
  closingRate: "closingRate",
  closingRatePerAssignee: "closingRatePerAssignee",
  avgTimePerStage: "avgTimePerStage",
  avgTime: "avgTime",
  chatsText: "chatsText",
  comments: "comments",
  addAComment: "addAComment",
  customer360Vision: "customer360Vision",
  isAContact: "isAContact",
  pipelineStage: "pipelineStage",
  salesCardFiltersLoadError: "salesCardFiltersLoadError",
  salesFiltersScope: "salesFiltersScope",
  salesCardLoadError: "salesCardLoadError",
  userOverview: "userOverview",
  noDeal: "noDeal",
  relatedTickets: "relatedTickets",
  activities: "activities",
  taskCreated: "taskCreated",
  noTickets: "noTickets",
  noLabels: "noLabels",
  chatTransferredTimeout: "chatTransferredTimeout",
  autoAssignDealUserTypes: "autoAssignDealUserTypes",
  nameOfOtherChannel: "nameOfOtherChannel",
  activityLogs: "activityLogs",
  chatrooms: "chatrooms",
  noChatrooms: "noChatrooms",
  unarchive: "unarchive",
  cannotArchiveConnectedChat: "cannotArchiveConnectedChat",
  createChatRoom: "createChatRoom",
  participants: "participants",
  canCreateChatRooms: "canCreateChatRooms",
  templateLanguage: "templateLanguage",
  selectContentType: "selectContentType",
  body: "body",
  id: "id",
  submittedForApproval: "submittedForApproval",
  applyForWaApproval: "applyForWaApproval",
  checkStatus: "checkStatus",
  templateApprovedByWa: "templateApprovedByWa",
  templateSubmittedForApproval: "templateSubmittedForApproval",
  waTemplateCreatedAndSendForApproval: "waTemplateCreatedAndSendForApproval",
  mediaUrl: "mediaUrl",
  mediaUrlPlaceholder: "mediaUrlPlaceholder",
  templateStatusIs: "templateStatusIs",
  listButtonText: "listButtonText",
  whatsappNotEnabled: "whatsappNotEnabled",
  twilioAuthError: "twilioAuthError",
  contentSupportedChannels: "contentSupportedChannels",
  subtitle: "subtitle",
  button: "button",
  language: "language",
  configureContent: "configureContent",
  waBusinessInitiated: "waBusinessInitiated",
  waBusinessInitiatedDescription: "waBusinessInitiatedDescription",
  samples: "samples",
  joinText: "joinText",
  fieldsMapping: "fieldsMapping",
  logAgentConnected: "logAgentConnected",
  logAgentDisconnected: "logAgentDisconnected",
  logAgentWillDisconnectIn: "logAgentWillDisconnectIn",
  logUpdatedUser: "logUpdatedUser",
  logBotUpdated: "logBotUpdated",
  logBotUpdatedByEdnaBot: "logBotUpdatedByEdnaBot",
  logBoardUpdated: "logBoardUpdated",
  logBoardDeleted: "logBoardDeleted",
  logBoardCreated: "logBoardCreated",
  logQuickReplyAdded: "logQuickReplyAdded",
  logQuickReplyUpdated: "logQuickReplyUpdated",
  logQuickReplyDeleted: "logQuickReplyDeleted",
  logLabelAdded: "logLabelAdded",
  logLabelDeleted: "logLabelDeleted",
  logCampaignCreated: "logCampaignCreated",
  logUserAssignedToChat: "logUserAssignedToChat",
  logUserRejectedAssignedChat: "logUserRejectedAssignedChat",
  logUserAcceptedAssignedChat: "logUserAcceptedAssignedChat",
  logLivestreamStarted: "logLivestreamStarted",
  logLivestreamStopped: "logLivestreamStopped",
  logTicketDeleted: "logTicketDeleted",
  logContactImported: "logContactImported",
  selectLogType: "selectLogType",
  contactImportLabelDescription: "contactImportLabelDescription",
  chatWillBeClosedInQueue: "chatWillBeClosedInQueue",
  autoOpenChat360ModalWhenAgentConnects:
    "autoOpenChat360ModalWhenAgentConnects",
  download: "download",
  contactLoadingError: "contactLoadingError",
  pin: "pin",
  chooseHowLongYourPinLasts: "chooseHowLongYourPinLasts",
  youCanUnpinAtAnyTime: "youCanUnpinAtAnyTime",
  daysVar: "daysVar",
  messagePinnedSuccess: "messagePinnedSuccess",
  autoAssignRoundRobinChat: "autoAssignRoundRobinChat",
  roundRobinChatTimeout: "roundRobinChatTimeout",
  ratingRate: "ratingRate",
  ratingType: "ratingType",
  rating: "rating",
  excludedDialogsCommaSeparated: "excludedDialogsCommaSeparated",
  transferChat: "transferChat",
  noGroupsAvailable: "noGroupsAvailable",
  chat: "chat",
  agent: "agent",
  ratingAnalysis: "ratingAnalysis",
  noRatingsFound: "noRatingsFound",
  latestDeals: "latestDeals",
  customFields: "customFields",
  manageCustomFields: "manageCustomFields",
  manage: "manage",
  setBody: "setBody",
  category: "category",
  searchQuickReplies: "searchQuickReplies",
  noQuickRepliesFound: "noQuickRepliesFound",
  metaData: "metaData",
  websiteUrl: "websiteUrl",
  waUserInitiatedDescription: "waUserInitiatedDescription",
  waUserInitiated: "waUserInitiated",
  waTemplateAllowDescription: "waTemplateAllowDescription",
  inProgress: "inProgress",
  completed: "completed",
  workflowEvents: "workflowEvents",
  failedReason: "failedReason",
  workflowRunXTimes: "workflowRunXTimes",
  completedCampaigns: "completedCampaigns",
  reset: "reset",
  chatACLAgentConnected: "chatACLAgentConnected",
  chatACLAgentDisconnected: "chatACLAgentDisconnected",
  chatACLAutomationBlocked: "chatACLAutomationBlocked",
  chatACLAutomationBlockedRepeatedInbound: "chatACLAutomationBlockedRepeatedInbound",
  chatACLAutomationBlockedInboundBurst: "chatACLAutomationBlockedInboundBurst",
  chatACLAutomationBlockedReciprocalLoop: "chatACLAutomationBlockedReciprocalLoop",
  chatACLAutomationBlockedManual: "chatACLAutomationBlockedManual",
  chatACLAutomationBlockedUnknown: "chatACLAutomationBlockedUnknown",
  chatACLLiveChatRequested: "chatACLLiveChatRequested",
  chatACLLiveChatTimeout: "chatACLLiveChatTimeout",
  chatACLAssignedByRoundRobin: "chatACLAssignedByRoundRobin",
  chatACLTransferredByRoundRobin: "chatACLTransferredByRoundRobin",
  chatACLTransferredToAgent: "chatACLTransferredToAgent",
  chatACLTransferredBackToAgent: "chatACLTransferredBackToAgent",
  chatACLTransferredToTeam: "chatACLTransferredToTeam",
  chatACLTransferredToAgentAutoAssigned:
    "chatACLTransferredToAgentAutoAssigned",
  chatACLTransferredTimeout: "chatACLTransferredTimeout",
  chatACLAgentAcceptedTransfer: "chatACLAgentAcceptedTransfer",
  chatACLAgentRejectedTransfer: "chatACLAgentRejectedTransfer",
  chatACLDialogTriggered: "chatACLDialogTriggered",
  vsYesterday: "vsYesterday",
  assignToGroup: "assignToGroup",
  teamVolume: "teamVolume",
  generalChatAccess: "generalChatAccess",
  disableACMForChatTransfer: "disableACMForChatTransfer",
  disableCCDForChatTransfer: "disableCCDForChatTransfer",
  botTransferredFrom: "botTransferredFrom",
  detailed: "detailed",
  agentStats: "agentStats",
  journeys: "journeys",
  flowMap: "flowMap",
  searchJourneyCategory: "searchJourneyCategory",
  noJourneyCategories: "noJourneyCategories",
  createJourneyCategory: "createJourneyCategory",
  editJourneyCategory: "editJourneyCategory",
  createJourney: "createJourney",
  editJourney: "editJourney",
  noJourneys: "noJourneys",
  journeyEvents: "journeyEvents",
  journeyRunXTimes: "journeyRunXTimes",
  journeyName: "journeyName",
  journeyBuilder: "journeyBuilder",
  duplicate: "duplicate",
  forms: "forms",
  editForm: "editForm",
  createForm: "createForm",
  useIntegration: "useIntegration",
  formCompleteMessage: "formCompleteMessage",
  newMessage: "newMessage",
  selectMessageTemplate: "selectMessageTemplate",
  agentAlreadyConnected: "agentAlreadyConnected",
  canSendMessageFromInbox: "canSendMessageFromInbox",
  cards: "cards",
  createCard: "createCard",
  canDisconnectAllChats: "canDisconnectAllChats",
  saveAsContact: "saveAsContact",
  chatAlreadyExists: "chatAlreadyExists",
  newMessageChatNotFound: "newMessageChatNotFound",
  liveChatRequest: "liveChatRequest",
  userRequestedLiveChat: "userRequestedLiveChat",
  canSkipClosingDialog: "canSkipClosingDialog",
  disconnectAndSkipClosingDialog: "disconnectAndSkipClosingDialog",
  disconnectNow: "disconnectNow",
  templates: "templates",
  setHeaders: "setHeaders",
  headers: "headers",
  apiBodyDescription: "apiBodyDescription",
  weighted: "weighted",
  chatConversionRate: "chatConversionRate",
  matching: "matching",
  submit: "submit",
  forgotPassword: "forgotPassword",
  backToLogin: "backToLogin",
  resetPasswordEmailSent: "resetPasswordEmailSent",
  capture: "capture",
  browse: "browse",
  captureResult: "captureResult",
  switchCamera: "switchCamera",
  testSMTP: "testSMTP",
  testIMAP: "testIMAP",
  receiverEmail: "receiverEmail",
  forward: "forward",
  forwardMessageTo: "forwardMessageTo",
  noResult: "noResult",
  messageForwardSuccess: "messageForwardSuccess",
  disableChatHistory: "disableChatHistory",
  enableGuestMode: "enableGuestMode",
  addGuestUser: "addGuestUser",
  messageGuestUserUpdateSuccess: "messageGuestUserUpdateSuccess",
  reason: "reason",
  lostDealReasons: "lostDealReasons",
  noLostDealReasonsFound: "noLostDealReasonsFound",
  openFullView: "openFullView",
  noEventsFound: "noEventsFound",
  fileLargerThanAllowedSize: "fileLargerThanAllowedSize",
  largeFileUpload: "largeFileUpload",
  setConfidential: "setConfidential",
  removeConfidential: "removeConfidential",
  chatAnalytics: "chatAnalytics",
  salesAnalytics: "salesAnalytics",
  campaignAnalytics: "campaignAnalytics",
  pipelineAssignee: "pipelineAssignee",
  setDefaultTheme: "setDefaultTheme",
  commentWillBeAvailableAfterSaving: "commentWillBeAvailableAfterSaving",
  restrictAllAnalytics: "restrictAllAnalytics",
  updateDeal: "updateDeal",
  updateDealAndStatus: "updateDealAndStatus",
  setConversationStatus: "setConversationStatus",
  updateAndDisconnect: "updateAndDisconnect",
  dealUpdateRequired: "dealUpdateRequired",
  backupLivecardId: "backupLivecardId",
  backupLivecardTimeout: "backupLivecardTimeout",
  transferedToBackupTeam: "transferedToBackupTeam",
  markAsDefault: "markAsDefault",
  sorting: "sorting",
  howManyConcurrentEvents: "howManyConcurrentEvents",
  averageSatisfactionRate: "averageSatisfactionRate",
  allContacts: "allContacts",
  segments: "segments",
  segmentSize: "segmentSize",
  createSegment: "createSegment",
  conditions: "conditions",
  thumbnailProduct: "thumbnailProduct",
  general: "general",
  workspace: "workspace",
  inbox: "inbox",
  active: "active",
  newCall: "newCall",
  callNow: "callNow",
  backupLivecards: "backupLivecards",
  linksTeamTicket: "linksTeamTicket",
  submitATicket: "submitATicket",
  urgent: "urgent",
  hideTextWhileSending: "hideTextWhileSending",
  defaultOpen: "defaultOpen",
  new: "new",
  customerServiceWindowExpired: "customerServiceWindowExpired",
  customerServiceWindowExpiredDescription:
    "customerServiceWindowExpiredDescription",
  learnMore: "learnMore",
  chatForwardedToBot: "chatForwardedToBot",
  chatForwardedToBotDescription: "chatForwardedToBotDescription",
  clearBotForwarding: "clearBotForwarding",
  workflowLogs: "workflowLogs",
  logs: "logs",
  compare: "compare",
  previousVersion: "previousVersion",
  currentVersion: "currentVersion",
  aIAgents: "aIAgents",
  createAIAgent: "createAIAgent",
  searchAgent: "searchAgent",
  noAgents: "noAgents",
  agentKnowledgeSources: "agentKnowledgeSources",
  agentChats: "agentChats",
  noChats: "noChats",
  connectedAt: "connectedAt",
  disconnectedAt: "disconnectedAt",
  connectedFrom: "connectedFrom",
  setupYourAlAgent: "setupYourAlAgent",
  setupYourAlAgentDescription: "setupYourAlAgentDescription",
  objective: "objective",
  prompt: "prompt",
  autoDisconnectChatAfter: "autoDisconnectChatAfter",
  replyWaitSeconds: "replyWaitSeconds",
  excludedJourneys: "excludedJourneys",
  excludedJourneysPlaceholder: "excludedJourneysPlaceholder",
  viewChats: "viewChats",
  agentCreated: "agentCreated",
  agentUpdated: "agentUpdated",
  agentDeleted: "agentDeleted",
  agentConfig: "agentConfig",
  actions: "actions",
  triggerType: "triggerType",
  analysis: "analysis",
  viewAnalysis: "viewAnalysis",
  messages: "messages",
  level: "level",
  metaCatalogId: "metaCatalogId",
  syncCatalog: "syncCatalog",
  catalogSynced: "catalogSynced",
  errorSyncingCatalog: "errorSyncingCatalog",
  quantity: "quantity",
  stock: "stock",
  hubs: "hubs",
  hasInvitedYouToJoin: "hasInvitedYouToJoin",
  leave: "leave",
  hubDeleteConfirmation: "hubDeleteConfirmation",
  hubLeaveConfirmation: "hubLeaveConfirmation",
  configureMetaDestinationOrder: "configureMetaDestinationOrder",
  configureMetaDestinationOrderDescription:
    "configureMetaDestinationOrderDescription",
  selectCatalog: "selectCatalog",
  knowledgeSources: "knowledgeSources",
  triggers: "triggers",
  completionRate: "completionRate",
  labelAlreadyExists: "labelAlreadyExists",
  markAsEnded: "markAsEnded",
  journeyLogs: "journeyLogs",
  setupIntegrationBitrixTitle: "setupIntegrationBitrixTitle",
  setupIntegrationBitrixDescription: "setupIntegrationBitrixDescription",
  work: "work",
  workItems: "workItems",
  workItem: "workItem",
  createNewItemType: "createNewItemType",
  workAnalytics: "workAnalytics",
  completedWorkItems: "completedWorkItems",
  incompleteWorkItems: "incompleteWorkItems",
  overdueWorkItems: "overdueWorkItems",
  totalWorkItems: "totalWorkItems",
  workItemsByColumn: "workItemsByColumn",
  workItemsByPriority: "workItemsByPriority",
  workItemsByAssignee: "workItemsByAssignee",
  workItemsByLabels: "workItemsByLabels",
  transactions: "transactions",
  addTransaction: "addTransaction",
  editTransaction: "editTransaction",
  totalAmount: "totalAmount",
  paid: "paid",
  noTransaction: "noTransaction",
  addNewTransaction: "addNewTransaction",
  workItemsByStatus: "workItemsByStatus",
  workItemsByAmount: "workItemsByAmount",
  team: "team",
  resolutionTime: "resolutionTime",
  days: "days",
  importJourney: "importJourney",
  journeyImportedSuccess: "journeyImportedSuccess",
  import: "import",
  filesSelected: "filesSelected",
  errorWhileImportingThisJourney: "errorWhileImportingThisJourney",
  journeyImportFailed: "journeyImportFailed",
  journeyExportedSuccessfully: "journeyExportedSuccessfully",
  setupIntegrationGoogleSheetTitle: "setupIntegrationGoogleSheetTitle",
  setupIntegrationGoogleSheetDescription:
    "setupIntegrationGoogleSheetDescription",
  sheetId: "sheetId",
  sheetRange: "sheetRange",
  chatACLJourneyTriggered: "chatACLJourneyTriggered",
  chatACLWorkflowTriggered: "chatACLWorkflowTriggered",
  chatACLWorkflowCompleted: "chatACLWorkflowCompleted",
  chatACLWorkflowFailed: "chatACLWorkflowFailed",
  defaultFallbackJourney: "defaultFallbackJourney",
  channelSpecificFallbackJourneys: "channelSpecificFallbackJourneys",
  senderGroupFallbackJourneys: "senderGroupFallbackJourneys",
  addSenderGroup: "addSenderGroup",
  editSenderGroup: "editSenderGroup",
  groupName: "groupName",
  senderIds: "senderIds",
  senderIdsHelp: "senderIdsHelp",
  greetingsJourneys: "greetingsJourneys",
  greetingsJourneysInfo: "greetingsJourneysInfo",
  scheduledChatClosingJourney: "scheduledChatClosingJourney",
  journeyId: "journeyId",
  owhChatRequestTriggered: "owhChatRequestTriggered",
  owhChatRequestProcessing: "owhChatRequestProcessing",
  owhChatRequestProceed: "owhChatRequestProceed",
  owhChatRequestCancelled: "owhChatRequestCancelled",
  receiptNumber: "receiptNumber",
  botInfo: "botInfo",
  botKey: "botKey",
  botPassword: "botPassword",
  restrictWorkItemCreation: "restrictWorkItemCreation",
  onlyCreatorOrAssigneeCanUpdateWorkItem:
    "onlyCreatorOrAssigneeCanUpdateWorkItem",
  onlyCreatorOrAssigneeCanDeleteWorkItem:
    "onlyCreatorOrAssigneeCanDeleteWorkItem",
  selectedLanguage: "selectedLanguage",
  enablePushNotification: "enablePushNotification",
  disablePushNotification: "disablePushNotification",
  disable2fa: "disable2fa",
  enable2fa: "enable2fa",
  chooseLanguage: "chooseLanguage",
  paymentMethodAnalytics: "paymentMethodAnalytics",
  paymentCount: "paymentCount",
  noPaymentsFound: "noPaymentsFound",
  today: "today",
  searchInConversation: "searchInConversation",
  foundMessages: "foundMessages",
  noMessagesFound: "noMessagesFound",
  restrictOnlyAssignedWorkItem: "restrictOnlyAssignedWorkItem",
  totalCost: "totalCost",
  ticketHistoryAdded: "ticketHistoryAdded",
  ticketHistoryMoved: "ticketHistoryMoved",
  adAnalysis: "adAnalysis",
  adId: "adId",
  metaWhatsappFlows: "metaWhatsappFlows",
  newWhatsappFlow: "newWhatsappFlow",
  buttonLabel: "buttonLabel",
  buttonLabelPlaceholder: "buttonLabelPlaceholder",
  messagePlaceholder: "messagePlaceholder",
  saveFormInContact: "saveFormInContact",
  completionMessage: "completionMessage",
  completionMessagePlaceholder: "completionMessagePlaceholder",
  screenTitle: "screenTitle",
  screenTitlePlaceholder: "screenTitlePlaceholder",
  noAgentConnected: "noAgentConnected",
  slotsFor: "slotsFor",
  addNewTimeSlot: "addNewTimeSlot",
  editTimeSlot: "editTimeSlot",
  scheduleAllDays: "scheduleAllDays",
  scheduleWeekdays: "scheduleWeekdays",
  scheduleWeekends: "scheduleWeekends",
  scheduleAllDay: "scheduleAllDay",
  scheduleDays: "scheduleDays",
  scheduleFrom: "scheduleFrom",
  scheduleTo: "scheduleTo",
  scheduleActions: "scheduleActions",
  scheduleEdit: "scheduleEdit",
  scheduleSave: "scheduleSave",
  scheduleCancel: "scheduleCancel",
  scheduleRemove: "scheduleRemove",
  scheduleAddSlot: "scheduleAddSlot",
  scheduleClear: "scheduleClear",
  copyToWeekdays: "copyToWeekdays",
  copyToWeekends: "copyToWeekends",
  copyToAllDays: "copyToAllDays",
  noSlotsForDay: "noSlotsForDay",
  enableConversationStatus: "enableConversationStatus",
  conversationStatusConfig: "conversationStatusConfig",
  conversationStatus: "conversationStatus",
  saved: "saved",
  amountSpent: "amountSpent",
  costPerMessageDelivered: "costPerMessageDelivered",
  messagesDelivered: "messagesDelivered",
  messagesRead: "messagesRead",
  messageReplies: "messageReplies",
  totalClicks: "totalClicks",
  uniqueClicks: "uniqueClicks",
  uniqueChats: "uniqueChats",
  clickRate: "clickRate",
  buttonClicks: "buttonClicks",
  graph: "graph",
  performance: "performance",
  trend: "trend",
  funnel: "funnel",
  selectQuestion: "selectQuestion",
  noFormTriggerFound: "noFormTriggerFound",
  totalChats: "totalChats",
  filteredChatsCount: "filteredChatsCount",
  viewDetails: "viewDetails",
  humanTransferConfig: "humanTransferConfig",
  conversationActions: "conversationActions",
  enableConversationActions: "enableConversationActions",
  conversationActionType: "conversationActionType",
  triggerJourney: "triggerJourney",
  selectJourney: "selectJourney",
  journeyActionHelpText: "journeyActionHelpText",
  enableHumanTransfer: "enableHumanTransfer",
  transferTargetType: "transferTargetType",
  transferToLiveCard: "transferToLiveCard",
  transferToSpecificAgents: "transferToSpecificAgents",
  selectLiveCard: "selectLiveCard",
  selectAgents: "selectAgents",
  transferMessageType: "transferMessageType",
  aiGeneratedMessage: "aiGeneratedMessage",
  configuredMessage: "configuredMessage",
  noMessage: "noMessage",
  transferMessage: "transferMessage",
  transferMessagePlaceholder: "transferMessagePlaceholder",
  fallbackMessage: "fallbackMessage",
  fallbackMessagePlaceholder: "fallbackMessagePlaceholder",
  autoAssignToAgent: "autoAssignToAgent",
  autoAssignHelpText: "autoAssignHelpText",
  transferCriteria: "transferCriteria",
  transferCriteriaPlaceholder: "transferCriteriaPlaceholder",
  transferCriteriaHelpText: "transferCriteriaHelpText",
  fallbackMessageType: "fallbackMessageType",
  addTransferConfig: "addTransferConfig",
  removeTransferConfig: "removeTransferConfig",
  transferConfigName: "transferConfigName",
  transferConfigNamePlaceholder: "transferConfigNamePlaceholder",
  selectAll: "selectAll",
  deselectAll: "deselectAll",
  assign: "assign",
  bulkAssignChats: "bulkAssignChats",
  bulkAssignSuccess: "bulkAssignSuccess",
  pendingMessages: "pendingMessages",
  selectItems: "selectItems",
  doneSelecting: "doneSelecting",
  selectAllLoaded: "selectAllLoaded",
  selectedOfLoaded: "selectedOfLoaded",
  bulkArchiveTitle: "bulkArchiveTitle",
  bulkArchiveConfirmation: "bulkArchiveConfirmation",
  bulkDeleteTitle: "bulkDeleteTitle",
  bulkDeleteConfirmation: "bulkDeleteConfirmation",
  bulkActionSuccess: "bulkActionSuccess",
  bulkActionPartialFailure: "bulkActionPartialFailure",
  campaignFileHelp: "campaignFileHelp",
  campaignFileReading: "campaignFileReading",
  campaignFileRemove: "campaignFileRemove",
  campaignFileSampleDownload: "campaignFileSampleDownload",
  campaignFilePreviewError: "campaignFilePreviewError",
  campaignFileSheet: "campaignFileSheet",
  campaignFileAdvancedSettings: "campaignFileAdvancedSettings",
  campaignFileHeaderRow: "campaignFileHeaderRow",
  campaignFileColumns: "campaignFileColumns",
  campaignFileDataRows: "campaignFileDataRows",
  campaignFileBlankRows: "campaignFileBlankRows",
  campaignFileValidRecipients: "campaignFileValidRecipients",
  campaignFileMissingRecipients: "campaignFileMissingRecipients",
  campaignFileInvalidRecipients: "campaignFileInvalidRecipients",
  campaignFileUniqueRecipients: "campaignFileUniqueRecipients",
  campaignFileDuplicateRows: "campaignFileDuplicateRows",
  campaignFileMissingValues: "campaignFileMissingValues",
  campaignFileMessagesReady: "campaignFileMessagesReady",
  campaignFileHiddenRows: "campaignFileHiddenRows",
  campaignFileRecipientColumn: "campaignFileRecipientColumn",
  campaignFileSelectRecipient: "campaignFileSelectRecipient",
  campaignFileRecipientHint: "campaignFileRecipientHint",
  campaignFileRecipientIdColumn: "campaignFileRecipientIdColumn",
  campaignFileSelectRecipientId: "campaignFileSelectRecipientId",
  campaignFileRecipientIdHint: "campaignFileRecipientIdHint",
  campaignFileNameSettings: "campaignFileNameSettings",
  campaignFileNameScope: "campaignFileNameScope",
  campaignFileNone: "campaignFileNone",
  campaignFileTemplateVariables: "campaignFileTemplateVariables",
  campaignFileCampaignScope: "campaignFileCampaignScope",
  campaignFileUsedIn: "campaignFileUsedIn",
  campaignFileSource: "campaignFileSource",
  campaignFileFileColumn: "campaignFileFileColumn",
  campaignFileContactField: "campaignFileContactField",
  campaignFileCustomText: "campaignFileCustomText",
  campaignFileColumn: "campaignFileColumn",
  campaignFileChooseMapping: "campaignFileChooseMapping",
  campaignFileFallback: "campaignFileFallback",
  campaignFileLiveContactHint: "campaignFileLiveContactHint",
  campaignFileRowIssues: "campaignFileRowIssues",
  campaignFileBlockIssues: "campaignFileBlockIssues",
  campaignFileSkipIssues: "campaignFileSkipIssues",
  campaignFileDuplicatePolicy: "campaignFileDuplicatePolicy",
  campaignFileKeepAll: "campaignFileKeepAll",
  campaignFileKeepFirst: "campaignFileKeepFirst",
  campaignFileDuplicateExplanation: "campaignFileDuplicateExplanation",
  campaignFileTemplate: "campaignFileTemplate",
  campaignFileTemplateBeforeUpload: "campaignFileTemplateBeforeUpload",
  campaignFileNoMediaPreview: "campaignFileNoMediaPreview",
  campaignFileMessagePreview: "campaignFileMessagePreview",
  campaignFilePreviewRow: "campaignFilePreviewRow",
  campaignFileRecipientUnavailable: "campaignFileRecipientUnavailable",
  campaignFilePrevious: "campaignFilePrevious",
  campaignFileSampleCount: "campaignFileSampleCount",
  campaignFileNext: "campaignFileNext",
  campaignFileDataAndIssues: "campaignFileDataAndIssues",
  campaignFileRow: "campaignFileRow",
  campaignFileReason: "campaignFileReason",
  campaignFileConflictingChats: "campaignFileConflictingChats",
  campaignFileChatIdentity: "campaignFileChatIdentity",
  campaignFileIdentityDigits: "campaignFileIdentityDigits",
  campaignFileIdentityMultiple: "campaignFileIdentityMultiple",
  campaignFileIdentityCount: "campaignFileIdentityCount",
  campaignFileIssuesBlocked: "campaignFileIssuesBlocked",
  campaignFileIssuesSkipped: "campaignFileIssuesSkipped",
  campaignFileLoadMoreIssues: "campaignFileLoadMoreIssues",
  campaignFileSampleRowsShown: "campaignFileSampleRowsShown",
  campaignFileRetry: "campaignFileRetry",
  campaignFilePreviewPending: "campaignFilePreviewPending",
  campaignFileEstimatedCost: "campaignFileEstimatedCost",
  campaignFileReview: "campaignFileReview",
  campaignFileSkippedRows: "campaignFileSkippedRows",
  campaignFileBackToAudience: "campaignFileBackToAudience",
  campaignFileReviewMapping: "campaignFileReviewMapping",
  campaignAudienceSettings: "campaignAudienceSettings",
  campaignAudienceSource: "campaignAudienceSource",
  campaignAudienceSourceHelp: "campaignAudienceSourceHelp",
  campaignAudienceExcel: "campaignAudienceExcel",
  campaignAudienceExcelHint: "campaignAudienceExcelHint",
  campaignAudienceManualHint: "campaignAudienceManualHint",
  campaignAudienceLabelHint: "campaignAudienceLabelHint",
  campaignAudiencePipelineHint: "campaignAudiencePipelineHint",
  campaignAudienceContinue: "campaignAudienceContinue",
  campaignAudienceUpload: "campaignAudienceUpload",
  campaignAudienceDropFile: "campaignAudienceDropFile",
  campaignAudienceFileHint: "campaignAudienceFileHint",
  campaignAudienceReplaceFile: "campaignAudienceReplaceFile",
  campaignAudienceChooseFile: "campaignAudienceChooseFile",
  campaignAudienceFileSummary: "campaignAudienceFileSummary",
  campaignAudienceContacts: "campaignAudienceContacts",
  campaignAudienceEmptyTitle: "campaignAudienceEmptyTitle",
  campaignAudienceEmptyHelp: "campaignAudienceEmptyHelp",
  campaignAudienceMatchColumns: "campaignAudienceMatchColumns",
  campaignAudienceMappingEmpty: "campaignAudienceMappingEmpty",
  campaignAudienceNoVariables: "campaignAudienceNoVariables",
  campaignAudienceExample: "campaignAudienceExample",
  campaignAudiencePreviewHint: "campaignAudiencePreviewHint",
  campaignAudienceReady: "campaignAudienceReady",
  campaignAudienceFinishSetup: "campaignAudienceFinishSetup",
  campaignAudienceIssues: "campaignAudienceIssues",
  campaignHelpName: "campaignHelpName",
  campaignHelpChannel: "campaignHelpChannel",
  campaignHelpCountry: "campaignHelpCountry",
  campaignHelpTemplate: "campaignHelpTemplate",
  campaignHelpGroup: "campaignHelpGroup",
  campaignHelpLabel: "campaignHelpLabel",
  campaignHelpPipeline: "campaignHelpPipeline",
  campaignHelpStage: "campaignHelpStage",
  campaignHelpManual: "campaignHelpManual",
  campaignHelpContactMapping: "campaignHelpContactMapping",
  campaignHelpSample: "campaignHelpSample",
  campaignHelpSheet: "campaignHelpSheet",
  campaignHelpVariables: "campaignHelpVariables",
  campaignHelpToken: "campaignHelpToken",
  campaignHelpFileValue: "campaignHelpFileValue",
  campaignHelpContactValue: "campaignHelpContactValue",
  campaignHelpLiteralValue: "campaignHelpLiteralValue",
  campaignHelpFallback: "campaignHelpFallback",
  campaignHelpHeader: "campaignHelpHeader",
  campaignHelpFirstName: "campaignHelpFirstName",
  campaignHelpLastName: "campaignHelpLastName",
  campaignHelpInvalidRows: "campaignHelpInvalidRows",
  campaignHelpDuplicates: "campaignHelpDuplicates",
  campaignHelpPreview: "campaignHelpPreview",
  campaignHelpReady: "campaignHelpReady",
  campaignHelpData: "campaignHelpData",
  campaignHelpCost: "campaignHelpCost",
  campaignHelpSchedule: "campaignHelpSchedule",
  campaignHelpStart: "campaignHelpStart",
  campaignHelpScheduleLabel: "campaignHelpScheduleLabel",
  campaignHelpScheduledFor: "campaignHelpScheduledFor",
  campaignHelpClearSchedule: "campaignHelpClearSchedule",
  campaignResultsTitle: "campaignResultsTitle",
  campaignResultsIntro: "campaignResultsIntro",
  campaignResultsStatusHelp: "campaignResultsStatusHelp",
  campaignResultsTotal: "campaignResultsTotal",
  campaignResultsRecipients: "campaignResultsRecipients",
  campaignResultsRecipient: "campaignResultsRecipient",
  campaignResultsChatHelp: "campaignResultsChatHelp",
  campaignResultsSearch: "campaignResultsSearch",
  campaignResultsLoadError: "campaignResultsLoadError",
  campaignResultsNoMatches: "campaignResultsNoMatches",
  campaignResultsEmpty: "campaignResultsEmpty",
  campaignResultsTime: "campaignResultsTime",
  campaignResultsPageCount: "campaignResultsPageCount",
  campaignResultsLoaded: "campaignResultsLoaded",
  campaignResultsUpdated: "campaignResultsUpdated",
  campaignResultsOpenChat: "campaignResultsOpenChat",
  campaignResultsNoText: "campaignResultsNoText",
  campaignResultsFailureReason: "campaignResultsFailureReason",
  campaignResultsUnknownFailure: "campaignResultsUnknownFailure",
  campaignResultsChatUnavailable: "campaignResultsChatUnavailable",
  campaignStatus: "campaignStatus",
  campaignWithInteraction: "campaignWithInteraction",
  campaignInactive: "campaignInactive",
  chatSources: "chatSources",
  chatSourceAds: "chatSourceAds",
  chatSourceOrganic: "chatSourceOrganic",
  chatSourceCampaign: "chatSourceCampaign",
  attributionWindow: "attributionWindow",
  percentOfTotal: "percentOfTotal",
  allTime: "allTime",
  chatOriginsActiveFrom: "chatOriginsActiveFrom",
  chatOriginsPreviewHelp: "chatOriginsPreviewHelp",
  allCategories: "allCategories",
  chatOriginsAll: "chatOriginsAll",
  allStatuses: "allStatuses",
  chatOriginsArchiveHelp: "chatOriginsArchiveHelp",
  businessAccount: "businessAccount",
  chatOriginsByCategory: "chatOriginsByCategory",
  chatOriginsByOrigin: "chatOriginsByOrigin",
  categories: "categories",
  categoryCreated: "categoryCreated",
  categoryName: "categoryName",
  chatOrigins: "chatOrigins",
  chatOrigin: "chatOrigin",
  chatOriginLoadError: "chatOriginLoadError",
  chatOriginsCategoryBreakdown: "chatOriginsCategoryBreakdown",
  chooseCategory: "chooseCategory",
  chatOriginsInvalidDateRange: "chatOriginsInvalidDateRange",
  copyLink: "copyLink",
  chatOriginsCopyPreviewError: "chatOriginsCopyPreviewError",
  chatOriginsCopyError: "chatOriginsCopyError",
  chatOriginsQrDownloadError: "chatOriginsQrDownloadError",
  chatOriginsActiveCountsHelp: "chatOriginsActiveCountsHelp",
  createCategory: "createCategory",
  createNewCategory: "createNewCategory",
  chatOriginsCreate: "chatOriginsCreate",
  dateRange: "dateRange",
  chatOriginsActiveDatesHelp: "chatOriginsActiveDatesHelp",
  chatOriginsDirectUnknown: "chatOriginsDirectUnknown",
  downloadCsv: "downloadCsv",
  downloadExcel: "downloadExcel",
  downloadQr: "downloadQr",
  chatOriginsReferenceHelp: "chatOriginsReferenceHelp",
  chatOriginsFirstTouchHelp: "chatOriginsFirstTouchHelp",
  chatOriginsEditAlias: "chatOriginsEditAlias",
  chatOriginsEdit: "chatOriginsEdit",
  chatOriginsFirstInbound: "chatOriginsFirstInbound",
  linkCopied: "linkCopied",
  chatOriginsTrackingHelp: "chatOriginsTrackingHelp",
  chatOriginsManage: "chatOriginsManage",
  chatOriginsMetaAd: "chatOriginsMetaAd",
  chatOriginsManageHelp: "chatOriginsManageHelp",
  newCategory: "newCategory",
  chatOriginsNew: "chatOriginsNew",
  chatOriginsEmpty: "chatOriginsEmpty",
  chatOriginsNoNumbers: "chatOriginsNoNumbers",
  chatOriginsUnattributedHelp: "chatOriginsUnattributedHelp",
  origin: "origin",
  chatOriginsCategories: "chatOriginsCategories",
  chatOriginsCreated: "chatOriginsCreated",
  chatOriginsName: "chatOriginsName",
  chatOriginsStatus: "chatOriginsStatus",
  chatOriginsUpdated: "chatOriginsUpdated",
  origins: "origins",
  chatOriginsOutsideActiveDates: "chatOriginsOutsideActiveDates",
  chatOriginsPrefilledMessage: "chatOriginsPrefilledMessage",
  chatOriginsQrLink: "chatOriginsQrLink",
  chatOriginsRefCode: "chatOriginsRefCode",
  chatOriginsRefreshCode: "chatOriginsRefreshCode",
  retry: "retry",
  chatOriginsSvgPrint: "chatOriginsSvgPrint",
  saveChanges: "saveChanges",
  chatOriginsSearch: "chatOriginsSearch",
  chatOriginsReportSearch: "chatOriginsReportSearch",
  chatOriginsNoSearchResults: "chatOriginsNoSearchResults",
  chatOriginsShare: "chatOriginsShare",
  chatOriginsDeleteCategory: "chatOriginsDeleteCategory",
  chatOriginsDeleteCategoryHelp: "chatOriginsDeleteCategoryHelp",
  chatOriginsCategoryDeleted: "chatOriginsCategoryDeleted",
  chatOriginsCategoryInUse: "chatOriginsCategoryInUse",
  chatOriginsDeletedCategory: "chatOriginsDeletedCategory",
  chatOriginsDeletedCategoryHelp: "chatOriginsDeletedCategoryHelp",
  chatOriginsMetaReadOnly: "chatOriginsMetaReadOnly",
  chatOriginsMetaAliasHelp: "chatOriginsMetaAliasHelp",
  chatOriginsSendHelp: "chatOriginsSendHelp",
  chatOriginsFixedLinkHelp: "chatOriginsFixedLinkHelp",
  chatOriginsAgentReferenceHelp: "chatOriginsAgentReferenceHelp",
  chatOriginsNameHelp: "chatOriginsNameHelp",
  chatOriginsActiveUntil: "chatOriginsActiveUntil",
  chatOriginsCustomerPreview: "chatOriginsCustomerPreview",
  whatsAppNumber: "whatsAppNumber",
  automaticShort: "automaticShort",
  chatOriginsLongMessageHelp: "chatOriginsLongMessageHelp",
  chatOriginsLoadError: "chatOriginsLoadError",
  chatOriginsLinkInfo: "chatOriginsLinkInfo",
  chatOriginsReference: "chatOriginsReference",
  chatOriginsChatsExport: "chatOriginsChatsExport",
  chatOriginsNewChats: "chatOriginsNewChats",
  chatOriginsCampaigns: "chatOriginsCampaigns",
  chatOriginsCampaignReplies: "chatOriginsCampaignReplies",
  chatOriginsTotalReplies: "chatOriginsTotalReplies",
  chatOriginsReplies: "chatOriginsReplies",
  chatOriginsReplyDate: "chatOriginsReplyDate",
  chatOriginsChatsReplies: "chatOriginsChatsReplies",
  chatOriginsWhatsAppCampaign: "chatOriginsWhatsAppCampaign",
  chatOriginsCampaignReadOnly: "chatOriginsCampaignReadOnly",
  chatOriginsCampaignAliasHelp: "chatOriginsCampaignAliasHelp",
  chatOriginsCampaignId: "chatOriginsCampaignId",
  chatOriginsOpenCampaign: "chatOriginsOpenCampaign",
  chatOriginsCampaignHelp: "chatOriginsCampaignHelp",
  chatOriginsCampaignEmpty: "chatOriginsCampaignEmpty",
  instagram: "instagram",
  weeks: "weeks",
  months: "months",
  years: "years",
};

export default locale;
